<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Recommendations from './recommendations'
import AddEdit from './addedit'

import axios from 'axios'

export default {
	page: {
		title: 'All Recommendations',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, AddEdit, Recommendations },
	data() {
		return {
			title: 'All Recommendations',
			category: 'List',
      newTag: null,
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'All Recommendations',
					active: true,
				},
			],
      recommendation: {
			  title: null,
        body: null,
        type: null,
        priority: null,
        tags: []
      },
      tagsOptions: [
          "EndPoint",
          "Network",
          "New Threat Global",
          "New Threat Local",
          "CyberThreat Intelligence",
          "Standard",
          "Policy",
          "Cloud",
          "Tentative"
      ],
      optionsType: [
        { value: 'Specific - Technical', text: 'Specific - Technical' },
        { value: 'Generic - Technical', text: 'Generic - Technical' },
        { value: 'Specific - Organizational', text: 'Specific - Organizational' },
        { value: 'Generic - Organizational', text: 'Generic - Organizational' },
        { value: 'Other', text: 'Other' }
      ],
      optionsPriority: [
        { value: 'Critical', text: 'Critical' },
        { value: 'Important', text: 'Important' },
        { value: 'Recommended', text: 'Good Practice' },
        { value: 'Useful', text: 'Useful' },
        { value: 'Informational', text: 'Informational' }
      ],
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
    }
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {
	  createNewRecommendation () {
      let that = this
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      axios.post(`${baseURL}/recommendations/create`, that.recommendation).then(response => {
        console.log('response', response)
      }).catch(e => {
        console.log(e);
      });
    },
    newRecommendation () {

      this.$refs.addEditComponent.showModal()
    },
    addNewTag() {
      this.recommendation.tags.push(this.newTag)
      this.tagsOptions.push(this.newTag)
    },
	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
  <div>
	<Layout>
		<PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-xl-2 col-lg-3 col-6">
                <img src="@assets/images/maintenance.svg" class="mr-4 align-self-center img-fluid " alt="cal">
              </div>
              <div class="col-xl-10 col-lg-9">
                <div class="mt-4 mt-lg-0">
                  <h4 class="mt-0 mb-1">Welcome to Recommendations</h4>
                  <p class="text-muted mb-2">During day to day operations of the detection and response service
                    we often find opportunities to improve our clients cybersecurity posture. Our recommendations can
                    range from specific points to general strategic approaches. In order to adopt a recommendation we strongly advice that the client validates all details inside their specific context.</p>
                  <button class="btn btn-primary mt-2 mr-1" @click="newRecommendation"><i class="uil-plus-circle"></i> Create New Recommendation</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<Recommendations
                :url="'/recommendations/list?withid=yes&include=incident.incident,incident.assets&limit=100'"
                :showDatetime=true
            />
					</div>
				</div>
			</div>
		</div>
	</Layout>
  <AddEdit
      :title="'Create New Recommendation'"
      :operation="'create'"
      ref="addEditComponent"
  />
  </div>
</template>
